import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

const modes = [
  { name: 'auto', icon: byPrefixAndName.fas['circle-half-stroke'] },
  { name: 'light', icon: byPrefixAndName.fas['sun-bright'] },
  { name: 'dark', icon: byPrefixAndName.fas.moon },
];

export default modes;
